import JustValidate from "just-validate";
import { swalModal } from "./modal.util";

export const getFormData = (form) => {
  const formFields = Array.from(form.elements)
    .filter((element) => element.name || element.id)
    .reduce((acc, element) => {
      const key = element.id || element.name;
      acc[key] = element.value.trim();
      return acc;
    }, {});

  const inputs = Object.keys(formFields).map((key) => `#${key}`);
  const values = Object.fromEntries(
    Object.entries(formFields).map(([key, value]) => [
      key.replace(/Input.*/, ""),
      value,
    ])
  );
  return { inputs, values };
};

export const initValidator = (form, validationRules) => {
  const validator = new JustValidate(form);
  validationRules.forEach(({ field, rules }) =>
    validator.addField(field, rules)
  );
  return validator;
};

export const sendForm = async (form, submitFunction, formData) => {
  try {
    const isSent = await submitFunction(formData);
    if (!isSent) throw new Error("Formulario falló al enviarse");
    swalModal({ success: true });
    form.reset();
    return true;
  } catch (err) {
    console.error("API Error:", err);
    swalModal({ success: false });
    return false;
  }
};

export const validateAndSendForm = (form, getRulesFn, submitFn, callback) => {
  const { inputs } = getFormData(form);
  const validator = initValidator(`#${form.id}`, getRulesFn(inputs));
  validator.onSuccess(async (event) => {
    event.preventDefault();
    try {
      const { values } = getFormData(form);
      const wasSendForm = await sendForm(form, submitFn, values);
      callback(wasSendForm);
    } catch (error) {
      console.error('Error during form submission:', error);
      callback(false);
    }
  });
  validator.onFail(() => {
    callback(false);
  });
};

export const initForms = (formList) => {
  formList.forEach(({ id, sendFn }) => {
    const form = document.getElementById(id);
    if (form) sendFn(form);
  });
};
